import { profilesApi } from '@/api';
import { ErrorNotificationIcon, SuccessNotificationIcon } from '@/assets/icons';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useComplainProfileById = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const mutation = useMutation({
        mutationFn: profilesApi.complainProfileById,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
            showToast({
                // type success
                icon: <SuccessNotificationIcon />,
                msg: 'Ваша жалоба получена'
            });
        },
        onError: (error) => {
            console.error('Error complain profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка отправки заявки'
            });
        },
    });

    return mutation;
};
